import React from "react";
import PropTypes from "prop-types";

// One code-native property mark for every address entry point. Keeping the
// silhouette here avoids small but noticeable differences between the homepage,
// verification flow, and navigation CTA as people move through the funnel.
const PropertyIcon = ({ size = 22 }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 3 2 12h3v8h14v-8h3z" />
  </svg>
);

PropertyIcon.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default PropertyIcon;
